import React, { useState } from "react";
import { fetchRSOGameSummary, fetchRSOHistory, fetchRSOTimeline } from "@shared/api";
import { regionV4toV5 } from "@shared/utils";
import { useApi } from "@shared/api/hooks";
import useAsyncEffect from "use-async-effect";
import { Match, MatchSummary } from "@shared/types/riot";
import { GameSummaryRSOView } from "@shared/modals/ImportGameModal/GameSummaryView";
import { useRSOToken } from "@shared/states/rsoState";
import { playbookState, resetMapState } from "@shared/states/frameState";
import { closeAllModals, matchState } from "@shared/states/uiStates";
import { saveNewCustomGame } from "@shared/api/custom_game";

export interface ImportCustomGameProps {}

const ImportCustomGame: React.FC<ImportCustomGameProps> = (props) => {
	const { loading, request } = useApi(fetchRSOHistory);
	const [history, setHistory] = useState<string[]>([]);
	const { request: requestSaveNewCustomGame } = useApi(saveNewCustomGame);
	const rso = useRSOToken();
	const { loading: loadingTimeline, request: requestTimeline } = useApi(fetchRSOTimeline);

	useAsyncEffect(async () => {
		if (!rso?.token) return;

		const response = await request(rso?.token.token, regionV4toV5(rso.token.region), "420");

		if (!response.history) {
			return;
		}
		setHistory(response?.history || []);
	}, [rso?.token]);

	const handleClick = async (summary: MatchSummary) => {
		if (!summary.platformId) {
			return;
		}

		const timeline = await requestTimeline(
			rso.token?.token!,
			regionV4toV5(summary.platformId),
			summary.platformId + "_" + summary.gameId,
		);

		const match: Match = {
			summary,
			timeline: timeline.timeline,
		};

		const saved_game = await requestSaveNewCustomGame({
			game_id: match.summary.gameName!,
			game_provider: "custom",
			match,
		});

		resetMapState();
		matchState.gameProvider = "custom";
		matchState.customGameId = saved_game.custom_game.id;
		matchState.match = match;
		playbookState.customGameId = saved_game.custom_game.id;
		playbookState.customMatchToken = saved_game.token;
		closeAllModals();
	};

	// todo show login?
	if (!rso?.token) return null;

	if (loading) {
		return <div className={"text-white"}>Loading Game History...</div>;
	}

	if (history.length === 0) {
		return <div className={"text-white opacity-80"}>No recent games found.</div>;
	}

	return (
		<div className={"max-h-96 overflow-y-scroll"}>
			{/*{!loading && error && <div className={"text-red-400 mt-2"}>{error.message}</div>}*/}
			{history?.map((gameId) => (
				<GameSummaryRSOView
					key={gameId}
					region={regionV4toV5(rso?.token?.region!)}
					gameId={gameId}
					playerId={rso.account?.puuid!}
					onClick={handleClick}
				/>
			))}
		</div>
	);
};

export { ImportCustomGame };
